{
  "copyrightLine": "© 2026 CARii",
  "links": [
    { "label": "Terms", "href": "#" },
    { "label": "Privacy", "href": "#" },
    { "label": "Cookies", "href": "#" }
  ]
}
